import { BrowserRouter, Routes, Route } from "react-router-dom";

import { GtmRouteListener } from "./analytics/GtmRouteListener";
import { AuthLayout } from "./layouts/AuthLayout";
import { CallbackPage } from "./pages/CallbackPage";
import { ForgotEmailPage } from "./pages/ForgotEmailPage";
import { ForgotPasswordPage } from "./pages/ForgotPasswordPage";
import { LoginPage } from "./pages/LoginPage";
import { SuccessPage } from "./pages/SuccessPage";
import { RegValuePropPage } from "./pages/RegValuePropPage";
import { RegisterSuccessPage } from "./pages/register/RegisterSuccessPage";
import { RegisterFeedbackPage } from "./pages/register/RegisterFeedbackPage";
import RegisterFlow from "./pages/register/RegisterFlow";
import { DownloadAppPage } from "./pages/DownloadApp/DownloadAppPage";

export function AppRoutes() {
  return (
    <BrowserRouter basename={import.meta.env.BASE_URL}>
      <GtmRouteListener />
      <Routes>
        <Route element={<AuthLayout />}>
          <Route path="/" element={<LoginPage />}  />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/forgot-email" element={<ForgotEmailPage />} />
          <Route path="/callback" element={<CallbackPage />} />
          <Route path="/success" element={<SuccessPage />} />
          <Route path="/register" element={<RegValuePropPage />} />
          <Route
            path="/register/create-account"
            element={<RegisterFlow />}
          />
          <Route path="/register/success" element={<RegisterSuccessPage />} />
          <Route path="/register/feedback" element={<RegisterFeedbackPage />} />
          <Route path="/register/download-app" element={<DownloadAppPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
